import { render, staticRenderFns } from "./manage-sidebar.vue?vue&type=template&id=402ea43e&scoped=true&"
import script from "./manage-sidebar.vue?vue&type=script&lang=js&"
export * from "./manage-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./manage-sidebar.vue?vue&type=style&index=0&id=402ea43e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402ea43e",
  null
  
)

export default component.exports